export enum BreakdownOriginType {
  Vandalism = 'vandalism',
  Misuse = 'misuse',
  WorksAtArrival = 'works_at_arrival',
  DefectiveMaterial = 'defective_material',
  External = 'external',
  NoCause = 'no_cause',
  Other = 'autre',
  Multiple = 'multiple',
}
